import { StyledModalFooterActions } from "../../../styles/StyledAddUpperDecision";
import { StyledField } from "../../../styles/StyledField";
import { Button } from "../../Button";
import AddIcon from "../../../assets/img/icons/add.svg";
import { postDecisionChunk, putDecisionChunk, getDecisionChunks, reorderDecisionChunks } from "../../../api/decision/decision";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { DecisionChunk } from "./DecisionChunk";
import { useQuery } from "react-query";
import { getLabelList } from "../../../api/decision/label";
import { Loader } from "../../Loader";
import { Field, Form, Formik } from "formik";
import { Select } from "../../Select";
import { Col, Row } from "react-grid-system";
import * as Yup from "yup";

type AddChunkProps = {
	id: string;
	closeModal: () => void;
	refetch: () => void;
	chunk: DecisionChunk | undefined;
	totalChunks: number;
};

const ChunkSchema = Yup.object().shape({
	title: Yup.string().required("Required"),
	description: Yup.string().required("Required"),
	label: Yup.number().required("Required"),
	order: Yup.number().required("Required"),
});

export const AddChunk = (props: AddChunkProps) => {
	const { id, closeModal, refetch, chunk, totalChunks } = props;
	const { axiosPrivate } = useAxiosPrivate();

	const { data: labelList, isLoading: isLoadingLabelList } = useQuery<{ id: number; name: string }[]>("labelList", () =>
		getLabelList(axiosPrivate)
	);

	const initialValues = {
		title: chunk?.title ?? "",
		description: chunk?.description ?? "",
		label: chunk?.label.id ?? null,
		order: chunk?.order ?? 1,
	};
	

	const handleUpdate = async (values: any) => {
		if (chunk) {
			const chunksBeforeUpdate = await getDecisionChunks(axiosPrivate, id);
			const otherChunks = chunksBeforeUpdate.filter((c: { id: number; }) => c.id !== chunk.id);
			otherChunks.splice(values.order - 1, 0, { ...chunk, ...values });
			const reordered = otherChunks.map((c: { id: any; }, index: number) => ({
				id: c.id,
				order: index + 1,
			}));
			await putDecisionChunk(axiosPrivate, id, chunk.id, values);
			await reorderDecisionChunks(axiosPrivate, id, reordered);

			closeModal();
			refetch();
		} else {
			await postDecisionChunk(axiosPrivate, id, values, () => {
				closeModal();
				refetch();
			});
		}
		return true;
	};


	return (
		<>
			<Formik initialValues={initialValues} onSubmit={handleUpdate} validationSchema={ChunkSchema}>
				{({ values, setFieldValue, errors, touched, isValid, isSubmitting }) => {
					return (
						<Form>
							<Row>
								<Col sm={9}>
									<StyledField>
										<label>Title</label>
										<Field name="title" />
										{errors.title && touched.title && <span>{errors.title}</span>}
									</StyledField>
								</Col>
								<Col sm={3}>
									<StyledField>
										<label>Label</label>
										{isLoadingLabelList ? (
											<>
												<Loader />
												<input type="text" />
											</>
										) : (
											<Select
												// @ts-expect-error to refactor
												options={labelList.map((el: { id: number; name: string }) => {
													return { value: el.id, label: el.name };
												})}
												value={values.label}
												onChange={setFieldValue}
												id="label"
												name="label"
												data-testid="label"
											/>
										)}
										{errors.label && touched.label && <span>{errors.label}</span>}
									</StyledField>
								</Col>
								<Col sm={3}>
									<StyledField>
									<label>Order</label>
									<Select
										// @ts-expect-error to refactor
										options={Array.from({ length: totalChunks + (chunk ? 0 : 1) }).map((_, i) => ({
										label: (i + 1).toString(),
										value: i + 1,
										}))}
										value={values.order}
										onChange={setFieldValue}
										id="order"
										name="order"
									/>
									{errors.order && touched.order && <span>{errors.order}</span>}
									</StyledField>
								</Col>
							</Row>
							<Row>
								<Col>
									<StyledField>
										<label>Content</label>
										<Field name="description" as="textarea" />
										{errors.description && touched.description && <span>{errors.description}</span>}
									</StyledField>
								</Col>
							</Row>
							<Row>
								<Col>
									<StyledModalFooterActions>
										<Button onClick={() => closeModal()} bg={false} small={true}>
											cancel
										</Button>
										<Button icon={AddIcon} type="submit" disabled={!isValid || isSubmitting}>
											Confirm
										</Button>
									</StyledModalFooterActions>
								</Col>
							</Row>
						</Form>
					);
				}}
			</Formik>
		</>
	);
};
